import { useEffect, useRef } from 'react'

interface CanvasWaveformProps {
  volumeBands: number[]
}

export const BarsWaveForm: React.FC<CanvasWaveformProps> = ({ volumeBands }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null)
  const intervalRef = useRef<number | null>(null)

  useEffect(() => {
    const draw = (): void => {
      const canvas = canvasRef.current
      if (!canvas) return

      const ctx = canvas.getContext('2d')
      if (!ctx) return

      canvas.width = canvas.clientWidth
      canvas.height = canvas.clientHeight

      const width = canvas.width
      const height = canvas.height / 1.6
      const barWidth = 16

      ctx.clearRect(0, 0, width, height)

      ctx.fillStyle = '#6662F9'
      ctx.lineJoin = 'round'
      ctx.lineCap = 'round'

      volumeBands.forEach((volume, i) => {
        const minHeight = height * 0.35 // Resting height when no sound
        const normalizedVolume = Math.max(volume * height, minHeight) // Ensures bars always have a base height
        const barHeight = normalizedVolume
        const x = i * barWidth
        const y = height - barHeight

        // Draw rounded bars (top + bottom)
        const radius = barWidth * 0.4 // Roundness of bars
        ctx.beginPath()
        ctx.moveTo(x + radius, y)
        ctx.arcTo(x + barWidth * 0.8, y, x + barWidth * 0.8, y + barHeight, radius)
        ctx.arcTo(x + barWidth * 0.8, y + barHeight, x, y + barHeight, radius)
        ctx.arcTo(x, y + barHeight, x, y, radius)
        ctx.arcTo(x, y, x + barWidth * 0.8, y, radius)
        ctx.closePath()
        ctx.fill()
      })

      ctx.restore()
      intervalRef.current = requestAnimationFrame(draw)
    }

    intervalRef.current = requestAnimationFrame(draw)

    return (): void => {
      if (intervalRef.current !== null) {
        cancelAnimationFrame(intervalRef.current)
      }
    }
  }, [volumeBands])

  return <canvas className="canvas" ref={canvasRef} />
}
